import "./header.css";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import NotificationBell from "./notification-bell";
import { authFetch, getDomain } from "../utils/apis/api";

const Header = ({ onBurgerClick }) => {
  const [profilePanel, openProfilePanel] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) return;
    authFetch(`${getDomain()}admin/notifications`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => { if (res.ok) setIsAdmin(true); })
      .catch(() => { });
  }, []);

  const handleProfileClick = () => openProfilePanel(!profilePanel);
  const handleOverlayClick = () => openProfilePanel(false);

  const showFullHeader =
    location.pathname.includes("chat") ||
    location.pathname.includes("dashboard") ||
    location.pathname.includes("veterans-portal");
  const isChatRoute = location.pathname.includes("chat");

  if (showFullHeader) {
    return (
      <div className="MainHeader">
        <div className="d-flex align-items-center">
          {/* Burger Icon - Visible only on small screens */}
          {isChatRoute && (
            <div className="burger-container" onClick={onBurgerClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
              </svg>
            </div>
          )}

          <Link className="header-brand-link" to="/chat">
            <h1 className="m-0 ps-2 pe-2">Tranquilla AI</h1>
          </Link>
          {
            sessionStorage.getItem('userType') === 'user' &&
            <>
              <div className="ps-3 border-start">{sessionStorage.getItem('agentName')}</div>
            </>
          }

        </div>

        <div className="profileContainer">
          {isChatRoute && sessionStorage.getItem('token') && <NotificationBell />}

          <button
            className="header-icon-btn"
            onClick={handleProfileClick}
            aria-label="Open menu"
            aria-haspopup="menu"
            aria-expanded={profilePanel}
          >
            <svg
              className="header-menu-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <circle cx="12" cy="5" r="2" />
              <circle cx="12" cy="12" r="2" />
              <circle cx="12" cy="19" r="2" />
            </svg>
          </button>
          {profilePanel && (
            <>
              <div className="overlay" onClick={handleOverlayClick} />
              <div className="profilePanel">
                <div className="email">
                  {sessionStorage.getItem('user_id')}
                </div>
                {isAdmin && (
                  <div className="admin-panel-link">
                    <Link to="/dashboard">Admin Panel</Link>
                  </div>
                )}
                <div className="profile-menu-link">
                  <Link to="/chat">Chat</Link>
                </div>
                <div className="profile-menu-link">
                  <Link to="/veterans-portal">Veterans Portal</Link>
                </div>
                <div onClick={() => sessionStorage.clear()} className="logout">
                  <Link to={((sessionStorage.getItem('userType') === 'user') && sessionStorage.getItem('agentName')) ? "/?agentName=" + sessionStorage.getItem('agentName') : "/"}>
                    Log out
                  </Link>
                </div>
              </div>
            </>
          )}
        </div>

      </div>
    );
  } else {
    return <div className="MainHeader"></div>;
  }
};

export default Header;
